import React, { useEffect, useState, useRef } from 'react';
import setting from '../../config.json';
import {
    MapContainer,
    TileLayer,
    Marker,
    Polyline,
    Tooltip,
    useMap,
    Popup
} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const data = [
    {
        "LocationNumber": 1,
        "Latitude": 14.5547,
        "Longitude": 121.0244,
        "Institution": "Makati Medical Center",
        "Address": "2 Amorsolo St, Legazpi Village, Makati City"
    },
    {
        "LocationNumber": 2,
        "Latitude": 14.5582,
        "Longitude": 121.0186,
        "Institution": "SM Mall of Asia",
        "Address": "Seaside Blvd, Pasay City"
    },
    {
        "LocationNumber": 3,
        "Latitude": 14.5995,
        "Longitude": 120.9842,
        "Institution": "Manila City Hall",
        "Address": "Antonio J. Villegas Rd, Ermita, Manila"
    },
    {
        "LocationNumber": 4,
        "Latitude": 14.6760,
        "Longitude": 121.0437,
        "Institution": "Quezon Memorial Circle",
        "Address": "Elliptical Rd, Diliman, Quezon City"
    },
    {
        "LocationNumber": 5,
        "Latitude": 14.5311,
        "Longitude": 121.0215,
        "Institution": "Glorietta",
        "Address": "Ayala Center, Makati City"
    },
    {
        "LocationNumber": 6,
        "Latitude": 14.5869,
        "Longitude": 121.0614,
        "Institution": "SM Megamall",
        "Address": "EDSA, Mandaluyong City"
    },
    {
        "LocationNumber": 7,
        "Latitude": 14.6507,
        "Longitude": 121.1029,
        "Institution": "Ateneo de Manila University",
        "Address": "Katipunan Ave, Loyola Heights, Quezon City"
    },
    {
        "LocationNumber": 8,
        "Latitude": 14.5176,
        "Longitude": 121.0509,
        "Institution": "Bonifacio Global City",
        "Address": "5th Ave, Taguig City"
    }
]

const OpalLocationTracker = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
    const [selectedVisual, setSelectedVisual] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const mapRef = useRef(null);

    const createMarker = item =>
        L.divIcon({
            className: '',
            html: `
      <div
        style="
          width:32px;
          height:32px;
          border-radius:50%;
          display:flex;
          align-items:center;
          justify-content:center;
          font-weight:700;
          font-size:14px;
          color:#000;
          background:rgba(255,255,255,0.85);
          box-shadow:0 1px 4px rgba(0,0,0,.2);
        "
      >
        ${item.location}
      </div>
    `,
            iconSize: [32, 32],
            iconAnchor: [16, 16]
        });

    function FitBounds({ positions }) {
    const map = useMap();

    useEffect(() => {
        if (!positions.length) return;

        if (positions.length === 1) {
            map.setView(positions[0], 16);
        } else {
            map.fitBounds(positions, {
                padding: [40, 40],
                maxZoom: 17,
            });
        }
    }, [map, positions]);

    return null;
}

    function HideAttribution() {
        const map = useMap();

        useEffect(() => {
            const attribution = map.attributionControl;

            if (attribution) {
                map.removeControl(attribution);
            }
        }, [map]);

        return null;
    }

    const series = chartConfig?.binding?.data?.series || {
        location: "location",
        lat: "lat",
        long: "long",
        value: "value",
        additionalValue: "additionalValue"
    };

    const sortedData = [...(chartData || [])]
        .map(item => ({
            location: Number(item[series.location]),
            lat: Number(item[series.lat]),
            long: Number(item[series.long]),
            value: item[series.value],
            additionalValue: item[series.additionalValue],
            originalData: item
        }))
        .filter(item =>
            !isNaN(item.lat) &&
            !isNaN(item.long) &&
            item.lat !== 0 &&
            item.long !== 0 &&
            item.location > 0
        )
        .sort((a, b) => a.location - b.location);

    const positions = sortedData.map(item => [
        item.lat,
        item.long
    ]);

    return (
        <div>
            <div className='chart-content'>
                <MapContainer
                    center={[14.5995, 120.9842]}   // any valid default location
                    zoom={13}
                    scrollWheelZoom={true}
                    style={{
                        width: "100%",
                        height: "100%",
                    }}
                >
                    <FitBounds positions={positions} />

                    <HideAttribution />

                    <TileLayer
                        url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                    />

                    <Polyline
                        positions={positions}
                        weight={4}
                    />

                    {sortedData.map(item => (
                        <Marker
                            key={item.location}
                            position={[item.lat, item.long]}
                            icon={createMarker(item)}
                            eventHandlers={{
                                mouseover: (e) => {
                                    e.target.openPopup();
                                },
                                mouseout: (e) => {
                                    e.target.closePopup();
                                }
                            }}
                        >
                            <Popup
                                autoPan
                                keepInView
                                closeButton={false}
                                maxWidth={250}
                            >
                                <div>
                                    <div style={{ fontWeight: 600 }}>
                                        {item.value}
                                    </div>
                                    <div>{item.additionalValue}</div>
                                </div>
                            </Popup>
                        </Marker>
                    ))}
                </MapContainer>
            </div>
        </div>
    );
};

export default OpalLocationTracker;